/* ═══ LA FICHA DE PRODUCTO ═════════════════════════════════════════════════
   Variantes · bolsa · barra anclada de celular. Sin librería, como el resto
   del sitio.

   🔴 EL CONTRATO CON SHOPIFY SE ESCRIBE AHORA, NO DESPUÉS.
   Este sitio todavía no vive en Shopify: la píldora del menú es cromo con
   `href="#"` y un (0) fijo. Había tres salidas y solo una no deja deuda:

     a) un botón «Agregar» que no agrega nada  → un botón que miente. No.
     b) un carrito local bonito, con su propia forma de guardar y su propio
        checkout → trabajo que se tira entero el día del tema. No.
     c) el marcado ES el de Shopify desde hoy — `<form action="/cart/add">`
        con `name="id"` y `name="quantity"`—, y encima de ese formulario
        corre una bolsa local para que el prototipo se pueda enseñar y probar.

   Se hizo (c). El día que esto sea un tema, lo único que falta es rellenar el
   `value` de cada `<option>`/`data-id` con el id numérico de la variante y
   BORRAR este archivo: el formulario ya postea a donde debe, con los nombres
   que Shopify espera, y el «Comprar ahora» ya apunta al permalink
   `/cart/{id}:{cantidad}`, que es el atajo oficial al checkout.

   ⚠️ Mientras tanto, «Ir a pagar» de la bolsa apunta a `/cart` — la ruta real
   de Shopify. En localhost eso da 404. Es a propósito: preferimos un enlace
   correcto que todavía no tiene servidor, a uno inventado que habría que
   cambiar. (Anotado para paco; no es algo que la clienta viva.)              */

(() => {
  const ficha = document.querySelector('[data-ficha]');
  if (!ficha) return;

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const pesos = n => '$' + n.toLocaleString('es-MX');

  /* ── 1 · LAS VARIANTES ──────────────────────────────────────────────────
     Una sola función para los dos mecanismos (discos de color y tarjetas de
     interior) porque el efecto es el mismo: recomponer el id que se va a
     postear y, si la variante cambia de foto, cambiarla.                    */
  const forma   = $('form[data-compra]');
  const campoId = forma && $('input[name=id]', forma);
  let heroImg = $('[data-hero-img]');
  const heroAlt = heroImg && heroImg.getAttribute('data-alt-base') || '';

  const estado = { color:null, interior:null };

  function recomponer(){
    if (!campoId) return;
    /* El id de variante de Shopify es UNO por combinación. Hasta que existan,
       se compone una clave legible con las opciones elegidas; el día del tema
       se sustituye por el `data-id` que traiga cada control. */
    const partes = [estado.color, estado.interior].filter(Boolean);
    /* 🔴 EN MINÚSCULAS. Los radios del sitio dicen `value="rayas"` y la
       variante de Shopify se llama «Rayas»: comparando tal cual, el journal
       NUNCA encuentra su id y el formulario postea vacío — sin un error. */
    const buscada = partes.join('/').toLowerCase();
    const dado = buscada && forma.querySelector(`[data-id][data-clave="${buscada}"]`);
    /* Sin muestras que elegir (Gratitude, la pluma) no hay partes: se cae a
       la primera marca en vez de dejar el campo vacío. */
    const respaldo = forma.querySelector('[data-id]');
    campoId.value = (dado || respaldo) ? (dado || respaldo).getAttribute('data-id') : '';

    const enlace = $('[data-comprar-ahora]');
    if (enlace) enlace.setAttribute('href',
      campoId.value ? `/cart/${encodeURIComponent(campoId.value)}:1` : '/cart');
  }

  /* ── EL CAMBIO DE FOTO AL ELEGIR COLOR ─────────────────────────────────
     🔴 MEDIDO ANTES DE TOCARLO, con la red a 900 kbps: al tocar una muestra el
     `<img>` se quedaba en `naturalWidth: 0` y `currentSrc` vacío durante unos
     150 ms — o sea, un HUECO BLANCO donde estaba el producto. Y solo 1 de las
     4 fotos de colorway estaba en caché: las otras tres se descargaban en el
     clic. Esto no se arregla con una animación encima; se arregla no dejando
     que pase.

     Dos piezas:
       1. **Precarga en reposo.** Las otras fotos se piden cuando el navegador
          no tiene nada mejor que hacer, en `low`. La primera muestra que toque
          ya está en memoria.
       2. **Decodificar ANTES de intercambiar.** Se arma una imagen aparte, se
          espera su `decode()` y solo entonces se cambia el `src` del que está
          en pantalla. Cero fotogramas en blanco.

     Y NO lleva fundido cruzado, a propósito. Medido en vivo (23-ago): la foto
     de producto de Papier corre con `transition: all 0s` y Aesop no tiene una
     sola transición en toda su ficha. Con el encuadre idéntico —es la misma
     toma en otro color— un corte seco se lee como que el objeto CAMBIA DE
     COLOR, que es la verdad; un fundido pondría dos libros fantasma encima uno
     del otro durante 200 ms.

     Lo único que sí se anima es la ESPERA: si decodificar tarda más de 140 ms
     (red lenta, primera vez), la foto baja de tono para decir «te oí, viene en
     camino». Es indicación de estado, no adorno — y por eso el umbral: por
     debajo de 140 ms el atenuado sería un parpadeo peor que el problema.     */
  const cache = new Map();
  function traer(url){
    if (cache.has(url)) return cache.get(url);
    const im = new Image();
    im.decoding = 'async'; im.fetchPriority = 'low'; im.src = url;
    const listo = (im.decode ? im.decode() : Promise.resolve()).catch(() => {});
    cache.set(url, listo);
    return listo;
  }
  /* Precarga en reposo: nunca compite con la foto que el visitante SÍ está
     viendo. Sin el `requestIdleCallback` esto retrasaría el LCP de la ficha. */
  const enReposo = window.requestIdleCallback || (f => setTimeout(f, 1200));
  /* 🔴 PERO NO CON DATOS CONTADOS. Medido en la ficha de la Planner a 390 px:
     los cuatro colorways pesan 1.39 MB (el terracota solo, 613 KB) y esta
     precarga los baja los CUATRO aunque el visitante no toque una sola muestra.
     En escritorio es un regalo; con el ahorro de datos puesto o en una red
     lenta es cobrarle un megabyte a alguien que pidió lo contrario. Ahí se
     renuncia a la instantaneidad y se cae al camino de siempre: `traer()` se
     sigue llamando en el clic, así que la foto llega, solo que no antes.
     `connection` no existe en Safari: sin el dato, se precarga como siempre. */
  const red = navigator.connection || {};
  const contados = red.saveData === true || /^([23]g|slow-2g)$/.test(red.effectiveType || '');
  /* 🔴 30-ago · Y TAMPOCO EN CELULAR, AUNQUE LA RED SEA BUENA. Medido en la
     ficha de la Planner: los cuatro colorways son **826 KB** que se bajan
     enteros aunque nadie toque una muestra. `saveData` no lo cubre —casi nadie
     lo enciende— y en un teléfono con 4G esos 826 KB son el 87% de todo lo que
     pesa la página en imágenes.
     El regalo se queda donde de verdad es un regalo: en escritorio, que es
     donde sobra banda y donde el cambio de color instantáneo se nota como
     lujo. En celular se cae al camino de siempre —`traer()` en el toque— y ese
     camino YA está diseñado: si la foto tarda más de 140 ms, la muestra se
     atenúa. O sea no aparece un hueco, aparece un estado que ya existía. */
  const anchura = matchMedia('(min-width: 900px)').matches;
  if (!contados && anchura)
    enReposo(() => $$('.tonos button').forEach(b => b.dataset.img && traer(b.dataset.img)));

  /* 🔴 NO SE REASIGNA EL `src` DEL <img> QUE ESTÁ EN PANTALLA. Primero lo hice
     así —precargar, `await decode()` sobre una imagen aparte, y luego
     `heroImg.src = url`— y MEDIDO EN PÍXELES seguía habiendo un fotograma
     blanco: luminancia 85 → **254** → 174. Asignar `src` resetea el elemento
     aunque el recurso ya esté decodificado en caché; lo que se decodificó fue
     OTRO objeto, no éste.
     La salida es sustituir el NODO: se clona el <img>, se le pone el src nuevo,
     se espera `decode()` **sobre el clon que va a entrar**, y solo entonces
     reemplaza al viejo. El anterior se queda pintado hasta el mismo fotograma
     en que entra el nuevo, que ya viene decodificado. */
  let turno = 0;
  async function cambiarFoto(url, alt){
    if (!heroImg || !url || heroImg.getAttribute('src') === url) return;
    const mio = ++turno;
    const lento = setTimeout(() => {
      if (mio === turno) heroImg.setAttribute('data-esperando', '');
    }, 140);

    const nuevo = heroImg.cloneNode(false);
    nuevo.removeAttribute('data-esperando');
    nuevo.src = url;
    if (alt) nuevo.alt = alt;
    /* `decode()` funciona sobre un elemento suelto, sin insertar. Si falla
       —formato raro, red caída— se sigue: más vale el corte seco de siempre
       que quedarse con la foto del color anterior. */
    await (nuevo.decode ? nuevo.decode().catch(() => {}) : traer(url));
    clearTimeout(lento);
    /* Si el visitante alcanzó a tocar otra muestra mientras ésta cargaba, la
       respuesta vieja se descarta. Sin esto, en red lenta la foto puede
       terminar en un color que ya nadie eligió. */
    if (mio !== turno) return;
    heroImg.replaceWith(nuevo);
    heroImg = nuevo;
  }

  /* Discos de color */
  $$('.tonos button').forEach(b => b.addEventListener('click', () => {
    $$('.tonos button').forEach(o => o.setAttribute('aria-pressed', String(o === b)));
    estado.color = b.dataset.color;
    const eco = $('[data-eco-color]'); if (eco) eco.textContent = b.dataset.color;
    cambiarFoto(b.dataset.img, `${heroAlt} en color ${b.dataset.color}`);
    recomponer();
  }));

  /* Tarjetas de interior (rayas / blank) */
  $$('.tarjetas input').forEach(r => r.addEventListener('change', () => {
    estado.interior = r.value;
    const eco = $('[data-eco-interior]'); if (eco) eco.textContent = r.dataset.nombre;
    recomponer();
  }));

  /* Estado inicial: se lee del marcado, no se asume. Si mañana la primera
     muestra cambia de orden, esto sigue diciendo la verdad. */
  const disco0 = $('.tonos button[aria-pressed=true]');
  if (disco0) estado.color = disco0.dataset.color;

  /* ── EL COLOR QUE VIENE DE LA PORTADA ────────────────────────────────────
     Si el enlace trae `?color=`, se pulsa esa muestra en vez de dejar la de por
     defecto. Se hace con `.click()` a propósito, no repitiendo aquí lo que hace
     el manejador: así el color entra por el MISMO camino —foto, eco del nombre
     y `recomponer()` que arma el id de variante— y no hay dos versiones de la
     misma lógica que se separen con el tiempo.
     🔴 Se compara el nombre TAL CUAL viaja en `data-color` («Orquídea», con
     tilde): no se inventa una tabla de babosas. La URL lo lleva codificado y
     `searchParams` lo devuelve ya decodificado, así que la comparación es
     directa. Si el color no existe —una URL vieja, un color descatalogado— no
     pasa nada: se queda el de por defecto en vez de dejar la ficha sin ninguno. */
  {
    const pedido = new URL(location).searchParams.get('color');
    if (pedido) {
      const disco = [...$$('.tonos button')]
        .find(b => b.dataset.color === pedido);
      if (disco && disco !== disco0) disco.click();
    }
  }
  const radio0 = $('.tarjetas input:checked');
  if (radio0) estado.interior = radio0.value;
  recomponer();

  /* ── 2 · LA BOLSA ───────────────────────────────────────────────────────
     🔴 YA NO VIVE AQUÍ. Vivía en este archivo, y este archivo solo se carga en
     las cinco fichas: agregar en una ficha y salir a /tienda dejaba el
     encabezado en «Carrito (0)» y sin cajón. Se mudó a `assets/bolsa.js`, que
     cargan las doce páginas. Aquí queda solo lo que es de la ficha: QUÉ se
     agrega. El CÓMO —guardar, pintar, abrir, trabar el fondo— es del sitio.  */
  const Bolsa = window.Bolsa;

  /* Lo que se va a agregar se LEE de la página en el momento del clic, no se
     cablea aquí: así las cuatro fichas comparten este archivo sin una tabla de
     productos duplicada que se desincronice de lo que se ve en pantalla. */
  function piezaActual(){
    const variante = [
      $('[data-eco-color]')?.textContent.trim(),
      $('[data-eco-interior]')?.textContent.trim()
    ].filter(Boolean).join(' · ');
    return {
      clave: `${ficha.dataset.sku}|${campoId ? campoId.value : ''}`,
      nombre: ficha.dataset.nombre,
      precio: Number(ficha.dataset.precio),
      variante,
      img: heroImg ? heroImg.getAttribute('src') : ''
    };
  }

  function complemento(){
    const c = $('#complemento');
    if (!c || !c.checked) return null;
    /* La clave lleva el id real: la bolsa lo necesita para postear, y sin él
       se negaría a agregar el renglón (que es lo correcto). */
    return { clave: c.dataset.id ? 'pluma|' + c.dataset.id : 'pluma',
             nombre:c.dataset.nombre, precio:Number(c.dataset.precio),
             variante:'', img:c.dataset.img };
  }

  if (forma) forma.addEventListener('submit', e => {
    /* En Shopify este `preventDefault` desaparece con el archivo y el POST se
       va solo. Aquí sostiene el prototipo. */
    e.preventDefault();
    /* Se resuelve AQUÍ, en el clic: para entonces `bolsa.js` ya corrió
       seguro, venga antes o después en el documento. */
    const B = window.Bolsa;
    if (!B) return;
    /* Los dos renglones en UNA llamada. Dos `agregar` seguidos lanzaban
       dos POST en paralelo contra el mismo carrito y el segundo se
       perdía: entraba la Planner y la pluma no. */
    B.agregar([piezaActual(), complemento()]);
    B.abrir();
  });


  /* ── 3 · LA BARRA ANCLADA DE CELULAR ────────────────────────────────────
     Aparece cuando el botón REAL sale de pantalla. Se observa el botón, no el
     scroll: esta página cambia de alto al abrir un cajón, y un umbral en
     píxeles se volvería mentira en cuanto alguien abra «Los detalles».      */
  const barra = $('.barra-pie'), ancla = forma && $('button[type=submit]', forma);
  if (barra && ancla && 'IntersectionObserver' in window){
    new IntersectionObserver(([e]) => {
      barra.toggleAttribute('data-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold:0 }).observe(ancla);
    $('button', barra).addEventListener('click', () => forma.requestSubmit());
  }
})();
